export default __webpack_public_path__ + "static/media/404.0aba4ccf.svg";